import { render, staticRenderFns } from "./CompanySendDocument.vue?vue&type=template&id=1fb6f665&scoped=true&"
import script from "./CompanySendDocument.vue?vue&type=script&lang=js&"
export * from "./CompanySendDocument.vue?vue&type=script&lang=js&"
import style0 from "./CompanySendDocument.vue?vue&type=style&index=0&id=1fb6f665&lang=scss&scoped=true&"
import style1 from "./CompanySendDocument.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb6f665",
  null
  
)

export default component.exports